/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SnsAccountInfo
 */
export interface SnsAccountInfo {
    /**
     * 
     * @type {string}
     * @memberof SnsAccountInfo
     */
    'snsId': string;
    /**
     * 
     * @type {string}
     * @memberof SnsAccountInfo
     */
    'snsAccountType': SnsAccountInfoSnsAccountTypeEnum;
}

export const SnsAccountInfoSnsAccountTypeEnum = {
    Viewup: 'viewup',
    ViewupPlus: 'viewupPlus'
} as const;

export type SnsAccountInfoSnsAccountTypeEnum = typeof SnsAccountInfoSnsAccountTypeEnum[keyof typeof SnsAccountInfoSnsAccountTypeEnum];


